<template>
  <div>
  
    
<b-row >
       
  <!----- SideBar All Design List ---->
   <div class="updateside">
     <sidebarSettingsComponent></sidebarSettingsComponent>
   </div>
  <!----- SideBar All Design List End ----> 


    <div class="design-container-details__main">
        <b-row class="col-md-12 updatesidebar">
          <b-col md="12" >
            <!-- <div class="pull-right"> -->
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret >
            <template v-slot:button-content>
            <!--   <span class="cui-options icons font-1xl d-block" style="font-size: 20px;"></span> -->
             <i class="fa fa-sliders" aria-hidden="true" style="font-size:20px"></i>
            </template>
            <b-dropdown-item style="font-size: 16px;"> 
            <div>
               <router-link to="/updateProfile" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Collections" style="padding-left:30px;"> 
          <i class="fa fa-pencil"></i>&nbsp;&nbsp;&nbsp; 
          <span>Profile</span>

          </router-link>
            </div>
            <div v-if="this.user_type=='Admin' || this.user_type=='Brand_Manager' || this.user_type=='Quality_Head' || this.user_type=='Quality_Controller'" >
            <router-link to="/usersdetails" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Collections" style="padding-left:30px;"> 
            <i class="fa fa-user"></i>&nbsp;&nbsp;&nbsp; 
            <span>Manage Users</span>

              </router-link>
        
           </div>
           <div v-if="this.user_type=='Brand_Manager' || this.user_type=='Quality_Head'">
            <router-link to="/mybranddetails" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Collections" style="padding-left:30px;"> 
              <i class="fa fa-shopping-cart" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp; 
            <span>My Brands</span>

            </router-link>
            
            </div>
            <div  style="display:none">
            <router-link to="/updateProfile" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
              <i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp; 
            <span>Manage Vendors</span>

            </router-link>
            </div>
            <div v-if="this.user_type=='Admin'">
            <router-link to="/manage_brands" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
              <i class="fa fa-users"></i>&nbsp;&nbsp;&nbsp; 
            <span>Manage Brands</span>

            </router-link>
            
            </div>
            <div v-if="this.user_type=='Admin'">
            <router-link to="/marginmaster" class="nav-link design-container-details__sidebar-item flex f-w-semi-bold " title="Coll ections" style="padding-left:30px;"> 
              <i class="fa fa-pie-chart" aria-hidden="true"></i>


                &nbsp;&nbsp;&nbsp; 
            <span>Manage Margin Master</span>

            </router-link>
            
           </div>

           </b-dropdown-item>
            
          

           

          </b-dropdown>
        <!-- </div> -->
          </b-col>
        </b-row>
      <!-- Code for Update Profile Photo -->
      <b-modal title="Update Photo" v-model="uploadphoto" @ok="uploadphoto = false">
          <template slot="modal-header" slot-scope="{ close }">
          <h5>Update Profile Photo</h5>
          </template>
          <template slot="default" slot-scope="{ hide }">
             <b-form @submit.prevent="validateForm3('form-5')" data-vv-scope="form-5">
                <b-form-group >
                    <label for="name">Upload File</label>
                    <b-form-file
                      v-model="file" name="file" ref="file"
                      :state="Boolean(file)"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                    ></b-form-file>
                    <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('file')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.file')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.file') }}
                      </code>
                      </b-input-group>
                 </b-form-group>

                
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button>
                  <b-button  size="sm" variant="danger" @click="uploadcancel()">cancel</b-button>
                </div>
              </b-form>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
      </b-modal> 
            <!-- Code For Update Profile Photo Ends -->

       <!-- Code for Edit  -->
      <b-modal title="Update Password" v-model="changepassword" @ok="changepassword = false">
          <template slot="modal-header" slot-scope="{ close }">
          <h5>Change Password</h5>
          </template>
          <template slot="default" slot-scope="{ hide }">
             <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5">
                <b-form-group
                  label="Change Password"
                  :label-cols="3" >
                  <b-form-input type="text" name="password"  v-model="customer.password" v-validate="'min:5'" :class="{'input': true, 'text-danger': errors.has('form-5.password') }" placeholder="Enter New Password">
                  </b-form-input>
                  <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('password')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.password')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.password') }}
                      </code>
                      </b-input-group>
                                 
                </b-form-group>

                
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button>
                  <b-button  size="sm" variant="danger" @click="editcancel()">cancel</b-button>
                </div>
              </b-form>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
      </b-modal> 
            <!-- Code For Edit Ends -->

             <!-- Code for Edit Profile -->
      <b-modal title="Edit Profile" v-model="changeprofile" @ok="changeprofile = false">
          <template slot="modal-header" slot-scope="{ close }">
          <h5>Edit Profile</h5>
          </template>
          <template slot="default" slot-scope="{ hide }">
             <b-form @submit.prevent="validateForm4('form-5')" data-vv-scope="form-5">
                <b-form-group
                  label="Name"
                  :label-cols="3" >
                  <b-form-input type="text" name="full_name"  v-model="fullName" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-5.full_name') }" placeholder="Enter New Name">
                  </b-form-input>
                  <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('full_name')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.full_name')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.full_name') }}
                      </code>
                      </b-input-group>
                                 
                </b-form-group>
                <b-form-group
                  label="Email ID"
                  :label-cols="3" >
                  <b-form-input type="text" name="email_id"  v-model="email_id" v-validate="'required|email'" :class="{'input': true, 'text-danger': errors.has('form-5.email_id') }" placeholder="Enter New Email ID">
                  </b-form-input>
                  <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('email_id')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.email_id')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.email_id') }}
                      </code>
                      </b-input-group>
                                 
                </b-form-group>

                <b-form-group
                  label="Mobile Number"
                  :label-cols="3" >
                  <b-form-input type="text" name="contact_no"  v-model="contact_no" maxlength="10" v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-5.contact_no') }" placeholder="Enter New Mobile Number">
                  </b-form-input>
                  <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('contact_no')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.contact_no')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.contact_no') }}
                      </code>
                      </b-input-group>
                                 
                </b-form-group>
                

                <!-- <b-form-group label="Role" :label-cols="3" >
                    <b-form-select v-model="customer.role" name="role" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-5.role') }">
                    <option value="">--Select--</option>
                    <option value="1">Admin</option>
                    <option value="2">User</option>
                  </b-form-select>
                  <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('role')" ></i>
                      </span>
                      <code v-show="errors.has('form-5.role')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-5.role') }}
                      </code>
                      </b-input-group>
                </b-form-group> -->
                  

                
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button>
                  <b-button  size="sm" variant="danger" @click="editprofilecancel()">cancel</b-button>
                </div>
              </b-form>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
      </b-modal> 
            <!-- Code For Edit Profile Ends -->



          <div class="col-md-12 profileset">

            <div class="profile-settings">

              <h3>Profile settings</h3>
             
              <!-- <button type="button" class="btn btn-default editprofile" @click="editprofileModal" id="editbtn"><i class="fa fa-pencil"></i>&nbsp;&nbsp;&nbsp;<span>Edit Profile</span></button> -->
              <div class="content">
                <div class="profile-fields-container">
                  <div class="tabular-fields" v-for="user in user_result" >
                    <div class="field-row">
                      <div class="field-label">Name</div>
                      <div class="field-value">{{user.full_name}}</div>
                    </div>
                    
                    <div class="field-row">
                      <div class="field-label">Email</div>
                      <div class="field-value">{{user.email_id}}</div>
                    </div>
                    <div class="field-row">
                      <div class="field-label">Mobile</div>
                        <div class="field-value"> {{user.contact_no}}</div>  
                    </div>
                    <div class="field-row">
                      <div class="field-label">Password</div>
                      <div class="field-value">
                        <div><button type="button" class="btn btn-default editpassword" @click="editinfoModal" id="pwd"><i class="fa fa-pencil"></i>&nbsp;&nbsp;&nbsp;<span>Change password</span></button></div>
                        

                        <div class="f-color-faded"> </div>
                      </div>
                    </div>
                    <!-- <div class="field-row">
                      <div class="field-label">Role</div>
                      <div class="field-value">{{user.role==1?'Admin':'User'}}</div>
                    </div> -->

                    <!-- <div class="field-row" v-if="user_type=='Buyer'">
                      <div class="field-label">Designation</div>
                      <div class="field-value">{{user.designation}}</div>
                    </div> -->

                    <div class="field-row">
                      <div class="field-label">Joined on</div>
                      <div class="field-value">
                        <div>{{user.created_date}}</div>
                      </div>
                    </div>

                    <!-- <div class="field-row" v-if="user_type!='Fit_Technician'">
                      <div class="field-label">Assigned Brand</div>
                      <div class="field-value">
                        <div>{{user.brand_title}}</div> 
                      </div>
                    </div>
                    <div class="field-row">
                      <div class="field-label">Assigned <br>Sub Category</div>
                      <div class="field-value" >
                        <tr v-for="assigned_subcat in assigned_sub_cat_id"><td>{{assigned_subcat.sub_cattitle}}</td></tr> 
                      </div>
                    </div> -->

                    <!-- <div class="field-row" v-if="user_type=='Brand_Manager'">
                      <div class="field-label">Do You have Design Head?</div>
                      <div class="field-value" >
                            <div>Yes&nbsp;<toggle-button v-model="dh_status" @change="changedesignhead();"/>&nbsp;No</div>
                        

                        <div class="f-color-faded"></div>
                      </div>
                     
                    </div> -->
                    <!-- <div class="field-row">
                      <div class="field-label">DEmo</div>
                      <div class="field-value">
                        <div><toggle-button v-model="dh_status" @change="changedesignhead();"/></div>
                        

                        <div class="f-color-faded"> </div>{{dh_status}}
                      </div>
                    </div> -->
                  </div>
                </div>
                <!-- <div v-if="!image">
                  <div  class="img img-invalid" style="background-image: url(&quot;null&quot;); " >
                      
                    </div>
                  <h4>Select an image</h4>
                    <input type="file" @change="onFileChange">
                </div> -->


                
                <!-- <div class="profileimg "> -->
                    
                  
                <!-- <div class="profile-image-container" style="margin-right: 5px;" > 
                  <div class="img img-invalid" style="background-image: url(&quot;null&quot;); background: none; border: 1px solid ">
                    <img alt="Image is not available"  v-bind:src="remoteUrl"  id="img">  
                    <div class="name-initials">P S</div>
                  </div>
                  
                  <div class="actions">
                    
                  </div>
                </div> -->

                <!-- <div >
                  <div >
                    <img src="" style="" alt="">
                    <input @change="uploadImage" class="custom-input" type="file" name="" accept="image/*"> 
                    <input type="file"  @change="upload($event)" id="file-input">
                  </div>-->
                  <!-- <div class="mt-10" style="text-align: center;">
                    <h4>Server Image</h4>
                    <img :src="remoteUrl" alt="">
                  </div> 

              </div>-->
              
              <!-- progressBar -->
              <!-- <div class="progress" id="progress_bar" style="display:none; margin-top: 5px; margin-bottom: 5px; width: 100%; height: 30px;font-size: 18px; font-weight: bold;">
                <div class="progress-bar progress-bar-info progress-bar-striped"
                 role="progressbar"
                 :aria-valuenow="progress"
                 aria-valuemin="0"
                 aria-valuemax="100"
                 :style="{height:'30px',text:'20px', align:'center', width:progress + '%'}"
                >
                 {{progress}}%
                  
                </div>
              </div> -->

              <!-- <label class="btn btn-default">
                <input type="file" ref="file" @change="selectFile"/>
              </label> -->

              <!-- <div style="margin-bottom: 5px; margin-top: 5px;"> -->
                <!-- <label  class="btn btn-default"> -->
                <!-- <input class="choosefile"  type="file" id="file"  ref="file" @change="selectFile"/> -->
              <!-- </label> -->
              <!-- </div> -->
                <!-- :disabled="!selectedFiles" -->
              <!-- <div>
                <button class="btn btn-info uploadbtn"  style="margin-right:5px" @click="uploads">Upload</button>
                <button class="btn btn-info removebtn" @click="removeImage" v-if="remoteUrl!=''">Remove Image</button>
              </div> -->


            <!-- </div>              -->
        
          </div>
        
    </div>
       </div>
    </div>  
</b-row>    





    
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import auth from '@/utils/auth'
import Vue from 'vue'
import Utils from "@/utils";
import { ToggleButton } from 'vue-js-toggle-button'
Vue.component('ToggleButton', ToggleButton)
// import auth from "@/utils/auth";



import sidebarSettingsComponent from './_sidebarSettingsComponent.vue'

const axios = require('axios')
export default {
  name: 'Tabs',
 components: {
    sidebarSettingsComponent
  },  
  data () {
    return {
     
      tabs: [
        'Calculator',
        'Shopping cart',
        'Charts'
      ],
     
        
        design_file_list:[],
        catselected: '',
        subcatselected:'',
        cat_title: '',
        sub_cat_title:'',
        created_date:'',
        title:'',
        id:0,
        design_no:'',        
        no:0,
      
        col_id:0,
        imgpath:'',
        totalRows: 0,
        visible : true,
        list: [],
        user_id: 0,
        messagedata: [],
        selectedId: 0,
        txtInput: '',
        selected: '',
        customer: {},
        user_result: [],
       


        selectedDate: new Date(),
        items:[],
        result:[],
        img_result: [],
        userdetails:[],
        totalRows: 0,
        user_id: '',
        assigned_sub_cat_id: [],
        design_details:[],
        changepassword: false,
        changeprofile: false,
        uploadphoto: false,
        file: '',
        arr: [],
        img_path:'',
        avatar: null,
         image: '',
    items: [1],
      activeTab: 1,
      selectedFile: null,
      remoteUrl:'',
      image1: {},
      isToggled: false,
      selected_brand_id: 0,
      dh_status:false,
      dh_avaliable_status: 0,
      user_type: '',

      //progressBar
       selectedFiles:'',
       currentFile:'',
       progress:0,
       message: "",
       fullName:'',
       contact_no:'',
       email_id:'',
       role:''
      // fileInfos:[]
    }
  },
  created: function() { 
    this.getusersdetails();
  this.id = this.$route.params.id;
  this.no=this.$route.params.no;
  this.col_id=this.$route.params.col_id;
  var userData = localStorage.getItem('userData');
  var userInfo = JSON.parse(userData);
  this.user_type = userInfo[0].user_type;
    //this.getdesignsummary(this.id);
   
  },
    methods: {  

  changedesignhead: function(){
    document.getElementById("overlay").style.display = "block";
    var is_dh_available;
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      if(this.dh_status== true){
        is_dh_available = 0;
      }
      else{
        is_dh_available = 1;
      }
        const Obj={
           brand_id: this.selected_brand_id,
          //brand_id: 344,
          is_dh_available: is_dh_available
        }
        axios.post(`${CONSTANTS.API_URL}/updatedesignhead`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {
            // Utils.notify("Design Head Updated Successfully", "success");
             this.$fire({
                 text:"Design Head Updated Successfully",
                 type: "success",
                 timer: 30000
                        })
            this.getusersdetails();
          }else {
           
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      //}
  },
    upload(event){
      //alert("Inn");
      //
      // const formData = new FormData();
      // formData.append("file", this.file);
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      let data = new FormData();
      let file = event.target.files[0];
      console.log(file);
      data.append('file', file)
      data.append('user_id',userInfo[0].user_id)
      let config = {
        header : {
         'Content-Type' : 'multipart/form-data'
       }
      }
      // Nazafat Code Start
      this.progress=0
      this.currentFile=file;
      //console.log(this.currentFile);



      // Nazafat Code End

      //if(file.type=='image/jpeg' || file.type=='image/png'){
     // const { image } = this;
      // const Obj={

      //       // user_id:userInfo[0].user_id,
      //       // image: image 
      //       file: this.file

      // }
      axios.post(`${CONSTANTS.API_URL}/uploadfiles`,data, config)
       .then(response => {
        this.progress = Math.round((100 * response.loaded) / response.total);
        document.getElementById("overlay").style.display = "none";
        this.remoteUrl = response.data.url;
        this.getusersdetails();
      }).then(response =>{
        this.message=response.data.message;
      })
       .catch((err) =>{
          return new Error(err.message);
          this.progress=0;
          this.message="Could not upload the file!";
          this.currentFile='';
        })
    //}
    // else{
    //   alert("Please Select JPG or PNG Format Image Only");
    //   this.remoteUrl = '';
    //   this.file='';
    // }

    },
    //new ends 

      //latest image code
      onFileChange(e) {

      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      //this.createImage(files[0]);
    },
    removeImage: function (e) {
      this.remoteUrl = '';
    },


      getImage(e){
        let image = e.target.files[0]
        let reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = e =>{
          this.avatar = e.target.result;
        }
      },

        editinfoModal: function(value) {

        this.customer.password = value.password,
        this.customer.user_id = value.user_id
        this.changepassword = !this.changepassword;
      },


    uploadprofileModal: function(value) {
      this.uploadphoto = !this.uploadphoto;
    },
    editprofileModal: function(value) {

      this.customer.name = value.name,
      this.customer.email_id = value.email_id,
      this.customer.mobile_no = value.mobile_no,
      this.customer.role = value.role,
      this.changeprofile = !this.changeprofile;
    },


    validateForm5(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
           this.updatepassword();
        }
      });
    },
    validateForm4(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
           this.updateprofile();
        }
      });
    },
    validateForm3(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
           this.updateprofilephoto();
        }
      });
    },

    updateprofile : function(){
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem('userData');

      var userInfo = JSON.parse(userData);
      
        const Obj={
          full_name: this.fullName,
          email_id: this.email_id,
          contact_no: this.contact_no,
          role: this.role,
          user_id: userInfo[0].user_id
        }
        axios.post(`${CONSTANTS.API_URL}/updateuserprofile`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data
          if (this.result.returnmsg === 'Successful') {
            // Utils.notify("Updated Successfully", "success");
              this.$fire({
                 text:"Updated Successfully",
                 type: "success",
                 timer: 30000
                        })
            this.changeprofile = !this.changeprofile;
            this.customer = {};
            this.getusersdetails();
            // this.getdesignsummary(this.id);
            
          }else {
           // alert(this.result.returnmsg);
            this.$fire({
                 text:this.result.returnmsg,
                 type: "error",
                 timer: 30000
                        })
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
      //}
  
    },  

    //progressBar!!!!!!!!!!
    selectFile(){
      this.selectedFiles = this.$refs.file.files;
      //console.log(this.selectedFiles);
    },
    uploads: function(){

       if(this.selectedFiles!=''){
      document.getElementById("progress_bar").style.display = "block";
      document.getElementById("overlay").style.display = "block";
      //console.log("hii",this.selectedFiles);
      this.progress=0;
      let file=this.selectedFiles.item(0);
      console.log(file);
      var userData = localStorage.getItem('userData');
      var userInfo = JSON.parse(userData);
      let data = new FormData();
       data.append('file', file)
      data.append('user_id',userInfo[0].user_id)
      // let config = {
      //   header : {
      //    'Content-Type' : 'multipart/form-data'
      //  },
      //  onUploadProgress:function(progressEvent){
      //     this.progress=Math.round((progressEvent.loaded * 100) / progressEvent.total);
      //     //console.log(percentCompleted)
      //     return this.progress;
      //     // if(percentCompleted<=100){
      //     //   this.progress=percentCompleted;
      //     //   console.log(this.progress);
      //     // }
      //   },
      // }

       //  axios.post(`${CONSTANTS.API_URL}/uploadfiles`,data, config)
       // .then(response=>{
       //  console.log(response);
       //  console.log(response.data);
       //  console.log(response.status);
       //  this.remoteUrl = response.data.url;
       // })
       axios.post(`${CONSTANTS.API_URL}/uploadfiles`,data, {
          header : {
         'Content-Type' : 'multipart/form-data'
       },
       onUploadProgress:function(progressEvent){
          this.progress=Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }.bind(this)
       }).then((response)=>{
        console.log(response);
          document.getElementById("overlay").style.display = "none";
        this.remoteUrl = response.data.url;
        // alert("File Uploaded Successfully");
         this.$fire({
                 text:"File Uploaded Successfully",
                 type: "success",
                 timer: 30000
                        })
        document.getElementById("progress_bar").style.display = "none";
        this.getusersdetails();
       })
     }
     else{
      // alert("Please Select File");
      this.$fire({
                 text:"Please Select File",
                 type: "warning",
                 timer: 30000
                        })

     }

    },

    updatepassword : function(){
      document.getElementById("overlay").style.display = "block";
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
        const Obj={
          password: `${this.customer.password}`,
          user_id: userInfo[0].user_id
        }
        axios.post(`${CONSTANTS.API_URL}/changeuserpassword`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.userdetails = response.data
          if (this.userdetails.returnmsg === 'Successful') {
            // Utils.notify("Updated Successfully", "success");
             this.$fire({
                 text:"Updated Successfully",
                 type: "success",
                 timer: 30000
                        })
            this.changepassword = !this.changepassword;
            this.customer = {};
            this.getusersdetails();
            // this.getdesignsummary(this.id);
            
          }else {
              // alert(this.userdetails.returnmsg);
              this.$fire({
                 text:this.userdetails.returnmsg,
                 type: "error",
                 timer: 30000
                        })
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
  
    },

      //function to get users details
      getusersdetails : function(){
        // alert("In")
      // document.getElementById("overlay").style.display = "block";
     var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)
        this.access_token=userInfo[0]['token']
        axios.defaults.headers.common['x-access-token'] = this.access_token;
        axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
        axios.defaults.headers.common['Accept']= 'application/json';
        axios.defaults.headers.common['Origin']='http://localhost:8080';

        const Obj={
          user_id: userInfo[0].user_id
        }
       axios.post(`${CONSTANTS.API_URL}/getloginuserdetails`,Obj)
        .then(response => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data
console.log("LLLLLLLLLLLLLLL",this.result)
          if (this.result.returnmsg === 'Successful') {
            console.log("LLLLLLLLLLLLLLL",this.result.returnvalue)
            this.user_result =this.result.returnvalue;
            this.fullName = this.user_result[0].full_name
            this.role = this.user_result[0].role
            this.email_id = this.user_result[0].email_id
            this.contact_no = this.user_result[0].contact_no
            this.assigned_sub_cat_id = this.user_result[0].subcat_assign;
            this.selected_brand_id = this.user_result[0].brand_assign;
            this.remoteUrl= this.user_result[0].profile_image;
            this.customer = {};
            this.dh_avaliable_status = this.user_result[0].is_dh_available;
            if(this.dh_avaliable_status== 0){
              this.dh_status = true;
            }
            else{
              this.dh_status = false;
            }
            // this.getdesignsummary(this.id);
            
          }else {
           this.user_result =[];
           this.totalRows=0;
             this.isBusy = !this.isBusy;
          }


        })
        .catch(e => {
          this.errors.push(e)
        })
  
    },

    editcancel: function() {
      this.customer = {};
      this.changepassword = !this.changepassword;
    },
    uploadcancel: function() {
      this.customer = {};
      this.uploadphoto = !this.uploadphoto;
    },

    editprofilecancel: function() {
      this.customer = {};
      this.changeprofile = !this.changeprofile;
    },

    currdate: function(date){
        var d = new Date(),
          minutes = d.getMinutes().toString().length == 1 ? '0'+d.getMinutes() : d.getMinutes(),
          hours = d.getHours().toString().length == 1 ? '0'+d.getHours() : d.getHours(),
          ampm = d.getHours() >= 12 ? 'pm' : 'am',
          months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
          days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        return days[d.getDay()]+' '+months[d.getMonth()]+' '+d.getDate()+' '+d.getFullYear();
  },
        

    /****** Function to design summary ********/
    // getdesignsummary: function (id) {
     
    //        var des_id=this.id
    //     this.isBusy = true;
    //     var userdata = localStorage.getItem('userData')
    //     var userInfo = JSON.parse(userdata);
        

    //     const Obj = {
    //          design_id: des_id,

           
    //        }

       
    //     axios.post(`${CONSTANTS.API_URL}/getdesigndetail`,Obj)
    //     .then(response => {
    //               this.result = response.data
    //       if (this.result.returnmsg === 'Successful') {

    //         this.design_details  = this.result.returnvalue;
    //         this.catselected=this.result.returnvalue[0].design_categoty_id
    //         this.subcatselected=this.result.returnvalue[0].design_categoty_id
    //         this.title=this.result.returnvalue[0].design_title
    //         this.id=this.result.returnvalue[0].design_id

    //         this.imgpath=this.result.returnvalue[0].design_image
    //         this.design_no = this.result.returnvalue[0].design_no

    //         this.cat_title=this.result.returnvalue[0].category_title
    //         this.sub_cat_title=this.result.returnvalue[0].sub_category_title
    //         this.created_date =this.result.returnvalue[0].created_date;

    //         this.measurement_file_display = this.result.returnvalue[0].measurement_file ==null ? '' : this.result.returnvalue[0].measurement_file;


    //         this.totalRows = this.result.returnvalue.length;

            
    //         this.isBusy = !this.isBusy;
            
    //       }else {
    //        this.design_details =[];
    //        this.totalRows=0;
    //          this.isBusy = !this.isBusy;
    //       }


    //     })
    //     .catch(e => {
    //       this.errors.push(e)
    //     })


    // },
    myRowClickHandler(record, index) {
    alert(index);

  },


/****** Function to UPDATE Design ********/   
    
    // updatedesign (scope) {
    //   this.id = this.$route.params.id;
    //     //alert("testing");
        
    //       const updesignObj = {
    //             design_title: this.title,
                            
    //               design_no : this.design_no,
    //               design_id : this.id,
    //                 design_categoty_id  : this.catselected,
    //               design_subcategoty_id   : this.subcatselected,
    //                is_delete:"0",
    //                image_path :this.imgpath,
                  
                 
    //               collection_id:this.col_id,

           
    //       }
          
    //        if (this.design_title !== '') {
    //         axios.post(`${CONSTANTS.API_URL}/updatedesign`,updesignObj)
    //         .then(response => {
    //             if(response.data.returnmsg == 'Successful') {

    //                 alert(" Design Updated Successfully.");
    //                 this.getusersdetails();
    //                 window.location.href ="/designsummry/"+ this.id ;
    //             } else {
    //               if (result.body.returnmsg === 'NoUserExists') {
                
    //                 this.showAlert=true
                    
    //               }
    //             }
    //           })
    //       }
      
      
    // },

// Nazafat Addition
    // selectFile(){
    //   this.selectedFiles=this.$refs.file.files[0];
    // },
    // upload(){
    //   var width=5;
    //   var increase =setInterval(function(){
    //     this.progress += width;
    //     if(this.progress  >= 100){
    //       clearInterval(increase);
    //     }
    //   },20);
    // },




        



  }
};
</script>
<style>
.account-settings__content>* {
    flex-grow: 1;
}

.profile-settings {
    flex-grow: 1;
    padding: 20px 24px;
}

.profile-settings>h1 {
    font-weight: 600;
    padding: 0;
    margin: 0;
}
.profile-settings .content {
    display: flex;
}
.profile-settings .content .profile-fields-container {
    max-width: 356px;
    margin-right: 56px;
}
.profile-settings .tabular-fields {
    font-size: 14px;
    line-height: 20px;
    flex-direction: column;
}
.profile-settings .tabular-fields .field-row {
    margin-top: 20px;
    min-height: 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.profile-settings .tabular-fields .field-row>.field-label {
    color: var(--fill-grey-medium);
    min-width: 100px;
    margin: 12px 0;
}
.profile-settings .tabular-fields .field-row>.field-value {
    margin-left: 32px;
    flex-grow: 1;
}

.design-container-details__main{
 
  background-color:white;
  border-left:1px solid #d4d4d4;

}

.profile-settings .content .img.img-invalid {
    background-color: #6f4ce6;
}
.profile-settings .content .img {
    max-width: 100%;
    position: relative;
    height: 175px;
    width: 175px;
    border-radius: 4px;
    overflow: hidden;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: contain;
    border: 1px solid var(--fill-grey-light2);
    padding: 5px;
}

  #pwd{
  background-color: #F8F8F8;
  color: #22A7F0;
}
#editbtn{
  background-color: #F8F8F8;
  color: #22A7F0;
  float: right;
}
#img {
    width: 100%;
    height: 100%;
    margin: auto;
    display: block;
    margin-bottom: 10px;
}
@media (max-width: 1040px)
{
 .updateside{
  display:none;
 }
}
@media (min-width: 1040px)
{
 .updatesidebar{
  display:none;
 }
}
@media (max-width: 766px)
{
 /*.profileimg{
  display:none;
 }*/
 #editbtn{
  background-color: #F8F8F8;
  color: #22A7F0;
  font-size:12px;
}
 .profile-settings .tabular-fields {
    font-size: 12px !important;
    line-height: 20px !important;
    flex-direction: column !important;
}
.profile-settings {
    flex-grow: 1 !important;
    padding: 15px 10px !important;
}
.profilerow{
  display: flex;
    flex-wrap: wrap;
    margin-right: 0px;
    margin-left: 0px;
}

}
@media (min-width: 765px){
    .profileimgsm{
     display:none;
 }
}
@media (max-width: 690px) and (min-width: 540px){
    .field-value{
    margin:0px !important;
 }
 .profileimg{
  margin-left: -45px !important;
  
 }
 .editprofile{
  font-size:11px !important;
 }
 .profile-image-container{
  width:110px !important;
 }
 .choosefile{
  font-size:11px !important;
 }
 .uploadbtn,.removebtn{
  font-size:11px !important;
 }
}
@media (max-width: 414px) and (min-width: 350px){
  .field-value{
    margin-left:-42px !important;
    overflow-wrap: anywhere !important;
 }
 .profileimg{
  margin-left: -45px !important;
  margin-right: -40px !important;
 }
 .profile-image-container{
  width:140px !important;
 }
 .choosefile{
  font-size:10px !important;
 }
 .uploadbtn,.removebtn{
  font-size:10px !important;
  padding:5px;
 }
 .editpassword{
  font-size:10px;
  padding:5px;
 }
  .editprofile{
  font-size:10px !important;
  margin-top: -70px !important;
    margin-right: 30px !important;
 }
}
 
 @media (max-width: 320px){
   .field-value{
    margin-left:-42px !important;
    overflow-wrap: anywhere !important;
 }
 .profileimg{
  margin-left: -45px !important;
   margin-right: -40px !important;
  
 }
 .profile-image-container{
  width:110px !important;
 }
 .choosefile{
  font-size:9px !important;
 }
 .uploadbtn,.removebtn{
  font-size:9px !important;
  padding:3px;
 }
 .editpassword{
  font-size:9px;
  padding:4px;
 }
  .editprofile{
  font-size:9px !important;
  margin-top: -70px !important;
    margin-right: 40px !important;
 }
 }


/* The switch - the box around the slider */
/*.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 22px;
}*/

/* Hide default HTML checkbox */
/*.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}*/

/* The slider */
/*.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 25px;
  width: 17px;
  left: 0px;
  bottom: 0px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(25px);
  -ms-transform: translateX(19px);
  transform: translateX(19px);
}*/

/* Rounded sliders */
/*.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}*/
/*input:checked + .slider:after
{  
  content:'No';
}*/
</style>